import React from 'react';

import CardPinModal from '@/components/card/card-info-with-functionality/card-pin/CardPinModal';

import { BlockAdultsWithLowAssurance } from '@components/block-adults-with-low-assurance';
import { DigitalCardLowAssuranceWarning, OnlyNativeAllowedWarning } from '@domain/digital-wallet';
import { CreditCard } from '@generated-types';

import { VirtualCardModal } from './VirtualCardModal';

const DigitalCard = ({ setModalState, modalState, card }: ModalsProps) => {
    const close = () => {
        setModalState({ ...modalState, showDigitalCardModal: false });
    };

    if (modalState.showDigitalCardModal) {
        return (
            <BlockAdultsWithLowAssurance
                onlyNativeAllowedWarning={<OnlyNativeAllowedWarning onClose={close} />}
                lowAssuranceWarning={<DigitalCardLowAssuranceWarning onClose={close} />}
            >
                <VirtualCardModal card={card} open={modalState.showDigitalCardModal} setOpen={close} />
            </BlockAdultsWithLowAssurance>
        );
    }

    return null;
};

export type ModalState = {
    showDigitalCardModal: boolean;
    showPinModal: boolean;
    showCardActivationModal: boolean;
};

interface ModalsProps {
    card: CreditCard;
    modalState: ModalState;
    setModalState: (state: ModalState) => void;
}

export const Modals = ({ card, modalState, setModalState }: ModalsProps) => {
    return (
        <>
            <DigitalCard card={card} modalState={modalState} setModalState={setModalState} />
            <CardPinModal
                open={modalState.showPinModal}
                setOpen={() => setModalState({ ...modalState, showPinModal: false })}
                card={card}
            />
        </>
    );
};
